import { ref, computed, watch, getCurrentInstance } from 'vue'

const TENANT_STORAGE_KEY = 'selected_tenant'

const selectedTenantId = ref(null)
const isInitialized = ref(false)

export function useTenantSelection() {
  const instance = getCurrentInstance()
  const store = instance?.proxy?.$store

  const tenants = computed(() => {
    const psuedoAllTenants = {id: null, name: 'All Tenants', tenant_group_id: null, tenant_group_name: null};
    const allTenants = [psuedoAllTenants, ...store?.state?.tenantsList]
    return allTenants;
  })

  const initializeFromStorage = () => {
    if (isInitialized.value) return

    try {
      const stored = localStorage.getItem(TENANT_STORAGE_KEY)
      if (stored) {
        selectedTenantId.value = stored
      }
    } catch (error) {
      console.warn('Failed to parse stored tenant selection:', error)
      localStorage.removeItem(TENANT_STORAGE_KEY)
    }

    isInitialized.value = true
  }

  const setTenant = (tenant) => {
    selectedTenantId.value = tenant
  }

  const clearTenant = () => {
    selectedTenantId.value = null
  }

  watch(
    selectedTenantId,
    (newTenantId) => {
      if (newTenantId) {
        localStorage.setItem(TENANT_STORAGE_KEY, newTenantId)
      } else {
        localStorage.removeItem(TENANT_STORAGE_KEY)
      }
    },
    { deep: true }
  )

  initializeFromStorage()

  return {
    tenants,
    selectedTenantId,
    setTenant,
    clearTenant
  }
}
